export const GET_CROSS_CHAINRECORD = 'GET_CROSS_CHAINRECORD'
